import { createIntl, createIntlCache } from 'react-intl';
import IntlMessageFormat from 'intl-messageformat';
import messages from '../translations/en.json';
import { stripeCountryDetails } from '../stripe-config';

const cache = createIntlCache();
const intl = createIntl({ locale: 'en', messages }, cache);
const formattedMessage = id => new IntlMessageFormat(intl.formatMessage({ id })).format({});

const supportedCountries = stripeCountryDetails.map(c => c.code);
export const geographicalFocusOptions = supportedCountries.map(c => {
  return { label: formattedMessage(`PayoutDetailsForm.countryNames.${c}`), key: c };
});
